export const NODA_LIVE: string = 'noda.live';
export const NODA_WEB_LINK: string = 'https://noda.live';
